import Vue from 'vue';
import service from '@/services/ap-review';
import { apError } from '@/utils/ap/commands';

const initialState = () => ({ context: null, invoiceId: null, epoch: 0, summary: null, pages: {}, loading: {}, errors: {}, navigation: { tab: 'lines', lineId: null } });

export function createAPReviewModule(api = service) {
    let sequence = 0;
    const activeReads = new Map();
    const cancelReads = () => {
        activeReads.forEach(read => read.cancel?.cancel());
        activeReads.clear();
    };
    return {
        namespaced: true,
        state: initialState,
        mutations: {
            reset(state, { context = null, invoiceId = null } = {}) {
                const epoch = state.epoch + 1;
                Object.assign(state, initialState(), { context, invoiceId, epoch });
            },
            summary(state, value) { state.summary = value; },
            page(state, { key, value }) { Vue.set(state.pages, key, value); },
            loading(state, { key, value }) { Vue.set(state.loading, key, value); },
            error(state, { key, value }) { Vue.set(state.errors, key, value); },
            navigation(state, value) { state.navigation = { ...state.navigation, ...value }; },
        },
        actions: {
            open({ commit }, context) {
                cancelReads();
                api.commands.clear();
                commit('reset', context);
            },
            clear({ commit }) {
                cancelReads();
                api.commands.clear();
                commit('reset');
            },
            async load({ state, commit }, { resource = 'summary', params = {} } = {}) {
                if (!state.invoiceId || !state.context) return;
                const epoch = state.epoch;
                const token = ++sequence;
                const key = resource;
                activeReads.get(key)?.cancel?.cancel();
                const cancel = api.cancelSource?.();
                activeReads.set(key, { token, cancel });
                const current = () => state.epoch === epoch && activeReads.get(key)?.token === token;
                commit('loading', { key, value: true });
                commit('error', { key, value: null });
                try {
                    const data = resource === 'summary' ? await api.summary(state.invoiceId, cancel?.token) : await api.page(state.invoiceId, resource, params, cancel?.token);
                    if (!current()) return;
                    if (resource === 'summary') commit('summary', data);
                    else commit('page', { key, value: { ...data, params } });
                    return data;
                } catch (error) {
                    if (current()) {
                        if (error.response?.status === 403 || error.response?.status === 404) {
                            cancelReads();
                            commit('reset', { context: state.context, invoiceId: state.invoiceId });
                            commit('error', { key: 'summary', value: apError(error) });
                        } else {
                            commit('error', { key, value: apError(error) });
                        }
                    }
                } finally {
                    if (current()) commit('loading', { key, value: false });
                }
            },
        },
    };
}

export default createAPReviewModule();
